export const acceptedFormat = 'image/jpeg, image/png, image/jpg'
export const baseSupportImage = './images/platform/default-user-icon.svg'
